export function passwordStrength (value) {
  let result = zxcvbn(value)
  console.log(result)
  return result.score >= 3
}

// @todo kod poniżej jest @deprecated, zostawić tylko w celu przepisanie niektórych części

/* eslint-disable camelcase */
import { getRequest } from '@/shared/utils/http'
import moment from 'moment'

import toNumber from 'lodash-es/toNumber'

export const checkRequired = (rules) => {
  if (typeof rules === 'undefined') {
    return false
  }
  return rules.hasOwnProperty('required')
}

const isUnique = (url, value, id = 0) => {
  return getRequest(url, { id: id, keyword: value })
    .then(response => {
      return {
        valid: response.valid,
        data: {
          message: response.data.message
        }
      }
    })
    .catch(error => {
      console.log(error)
    })
}

const ajaxValidation = (url, value) => {
  return getRequest(url, { keyword: value })
    .then(response => {
      return {
        valid: response.valid,
        data: {
          message: response.data.message
        }
      }
    })
    .catch(error => {
      console.log(error)
    })
}

const rules = {
  password_strength: {
    validate: value => {
      let result = zxcvbn(value)
      return result.score >= 3
    },
    getMessage: field => 'Proszę podaj silne hasło'
  },

  user_unique: {
    validate: (value, [id]) => isUnique('/api/users/unique', value, id),
    getMessage: (field, params, data) => {
      return data.message
    }
  },

  front_user_unique: {
    validate: (value, [id]) => isUnique('/api/front/users/unique', value, id),
    getMessage: (field, params, data) => {
      return data.message
    }
  },

  number_unique: {
    validate: (value, [id]) => isUnique('/api/agency/unique_number', value, id),
    getMessage: (field, params, data) => {
      return data.message
    }
  },

  number_local_unique: {
    validate: (value, [id]) => isUnique('/api/agency/unique_number_local', value, id),
    getMessage: (field, params, data) => {
      return data.message
    }
  },

  name_unique: {
    validate: (value, [id]) => isUnique('/api/agency/unique_name', value, id),
    getMessage: (field, params, data) => {
      return data.message
    }
  },

  role_name_unique: {
    validate: (value, [id]) => isUnique('/api/roles/unique_name', value, id),
    getMessage: (field, params, data) => {
      return data.message
    }
  },

  role_display_name_unique: {
    validate: (value, [id]) => isUnique('/api/roles/unique_display_name', value, id),
    getMessage: (field, params, data) => {
      return data.message
    }
  },

  nip: {
    validate: (value) => ajaxValidation('/api/validation/nip', value),
    getMessage: (field, params, data) => {
      return data.message
    }
  },

  iban: {
    validate: (value) => ajaxValidation('/api/validation/iban', value),
    getMessage: (field, params, data) => {
      return data.message
    }
  },

  min_money: {
    validate: value => {
      if (!value) {
        return false
      }
      return parseFloat(value) > 0
      // return parseFloat(value.replace(',', '.')) > 0
    },
    getMessage: (field, params, data) => {
      return `Pole ${field} powinno zawierać kwotę większą od 0`
    }
  }
}

export default (Validator) => {
  Object.keys(rules).forEach(rule => {
    Validator.extend(rule, rules[rule])
  })

  const monthAfter = {
    validate: (value, [otherValue]) => {
      if (otherValue && value) {
        const startDate = moment(otherValue, moment.HTML5_FMT.MONTH)
        const endDate = moment(value, moment.HTML5_FMT.MONTH)
        return startDate <= endDate
      }

      return true
    },
    getMessage: (field, [target, inclusion]) => {
      return `Pole ${field} musi być po polu ${target}`
    }
  }

  const minMonth = {
    validate: (value, [args]) => {
      if (args && value) {
        const startDate = moment(args, moment.HTML5_FMT.MONTH)
        const endDate = moment(value, moment.HTML5_FMT.MONTH)
        return startDate <= endDate
      }

      return false
    },
    getMessage: (field, [target, inclusion]) => {
      return `Pole ${field} musi mieć wartość co najmniej ${target}`
    }
  }

  Validator.extend('month_after', monthAfter, { hasTarget: true })
  Validator.extend('min_month', minMonth)
}

export const generalRules = {
  required: {
    required: true
  },
  money_required: {
    required: true,
    decimal: [2, '.'],
    min_money: true
  },
  nip_required: {
    required: true,
    length: 10,
    nip: true
  },
  nip: {
    length: 10,
    nip: true
  },
  regon: {
    max: 15
  },
  krs: {
    max: 20
  },
  bup_knf_number: {
    max: 20
  },
  iban_required: {
    required: true,
    length: 32,
    iban: true
  },
  iban: {
    length: 32,
    iban: true
  }
}

// @deprecated rules below
export const ruleEmail = { type: 'email', message: 'Podaj prawidłowy adres e-mail', trigger: 'blur' }

export function ruleRequired (field) {
  return {
    required: true,
    message: `Pole ${field} jest wymagane`,
    trigger: 'blur'
  }
}

export function ruleMinMax (field, min = false, max = false) {
  if (min && max) {
    return {
      min,
      max,
      message: `Pole ${field} nie może być krótsze niż ${min} i dłuższe niż ${max} znaków`,
      trigger: 'blur'
    }
  }
  if (min) {
    return {
      min,
      message: `Pole ${field} nie może być krótsze niż ${min} znaków`,
      trigger: 'blur'
    }
  }
  return {
    max,
    message: `Pole ${field} nie może być dłuższe niż ${max} znaków`,
    trigger: 'blur'
  }
}

export function ruleLength (field, l) {
  return {
    len: l,
    message: `Pole ${field} musi mieć ${l} znaków`,
    trigger: 'blur'
  }
}

export function ruleNumber (field) {
  return {
    type: 'number',
    message: `Pole ${field} musi być liczbą.`,
    trigger: 'blur'
  }
}

export function ruleInteger (field) {
  return {
    type: 'number',
    message: `Pole ${field} musi być liczbą całkowitą.`,
    trigger: 'blur'
  }
}

export function ruleFloat (field) {
  return {
    type: 'float',
    message: `Pole ${field} musi być liczbą zmiennoprzecinkową.`,
    trigger: 'blur',
    transform: (value) => {
      if (value === null) {
        return null
      }
      value = value.trim()
      return toNumber(value.replace(',', '.'))
    }
  }
}

export function ruleMoney (field) {
  console.log(field)
  return {
    type: 'boolean',
    message: `Pole ${field} musi być poprawną kwotą.`,
    trigger: 'blur',
    transform: (value) => {
      if (value === null) {
        return null
      }
      value = value.trim()
      return toNumber(value.replace(',', '.'))
    }
  }
}

export function ruleUrl (field) {
  return {
    type: 'url',
    message: `Format ${field} jest nieprawidłowy.`,
    trigger: 'blur'
  }
}

export function validatorPasswordStrength (field, value, callback) {
  let result = zxcvbn(value)
  if (result.score < 3) {
    callback(new Error('Proszę podaj silne hasło'))
  }
  callback()
}

export function ruleAjax (method, message) {
  const fn = (rule, value, callback) => {
    console.log(value)
    getRequest('/api/validation/' + method, { keyword: value })
      .then(response => {
        if (!response.valid) {
          callback(new Error(message))
        }
        callback()
      })
      .catch(error => {
        console.log(error)
        callback()
      })
  }
  return { validator: fn, trigger: 'blur' }
}

export function ruleAjaxUnique (url, id = 0, message = 'Podana wartość nie jest unikalna.') {
  const fn = (rule, value, callback) => {
    getRequest(url, { id: id, keyword: value })
      .then(response => {
        if (!response.valid) {
          callback(new Error(message))
        }
        callback()
      })
      .catch(error => {
        console.log(error)
        callback()
      })
  }
  return { validator: fn, trigger: 'blur' }
}

export function ruleIban () {
  return ruleAjax('iban', 'Numer konta bankowego jest niepoprawny.')
}

// export default {
//   ruleEmail,
//   ruleRequired,
//   validatorPasswordStrength,
//   ruleMinMax,
//   ruleLength,
//   ruleNumber,
//   ruleInteger,
//   ruleFloat,
//   ruleMoney,
//   ruleUrl,
//   ruleAjax,
//   ruleAjaxUnique
// }



// WEBPACK FOOTER //
// ./resources/js/shared/utils/validation.js